function RosterInstructions() {
  const baseTestId = 'roster-instructions';

  return (
    <div
      className='ds-c-alert ds-u-margin-top--3 ds-u-margin-bottom--3'
      data-testid={baseTestId}>
      <div
        className='ds-c-alert__body'
        data-testid={`${baseTestId}-body`}>
        <h2
          className='ds-c-alert__heading'
          data-testid={`${baseTestId}-heading`}>
          Choose Labor Categories for each user
        </h2>
        <div
          className='ds-c-alert__text'
          data-testid={`${baseTestId}-text`}>
          <p
            className='ds-u-margin-top--2'
            data-testid={`${baseTestId}-intro`}>
            When removing a user, confirm the removal in the dialog that appears when you click "Remove".
          </p>
          <ul
            className='ds-u-margin-top--2'
            data-testid={`${baseTestId}-list`}>
            <li>
              Do you have more than one user needing their Labor Categories added? Read the{' '}
              <a
                className='ds-c-link'
                data-testid={`${baseTestId}-bulk-link`}
                href='/help/bulk-roster-update'
                rel='noopener noreferrer'
                target='_blank'>
                instructions for requesting a bulk update to the Roster
              </a>
              .
            </li>
            <li>
              If someone is missing from the roster that does not require a EUA account please open a{' '}
              <a
                className='ds-c-link'
                data-testid={`${baseTestId}-service-request-link`}
                href='/support/service-request'
                rel='noopener noreferrer'
                target='_blank'>
                service request
              </a>{' '}
              to have them added.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default RosterInstructions;
